module.exports = __webpack_public_path__ + "img/filter.1c5f682f.svg";